<template>
  <div class="section"
       style="background-image: url('img/header.jpg'); background-size: cover; background-position: top center; min-height: 600px;">
    <div v-if="content" class="dynamic-content container text-center">
      <h1 class="h1"><strong>{{ content.fields.title }}</strong></h1>
      <div class="text-left information">
        <rich-text-renderer :document="content.fields.content"/>

      </div>
    </div>
  </div>
</template>
<script>
import {Parallax} from '@/components';
import {createContentfulClient} from "@/api/ContentfulClient";
import RichTextRenderer from 'contentful-rich-text-vue-renderer';

const client = createContentfulClient();

export default {
  name: 'more',
  components: {
    Parallax,
    RichTextRenderer
  },
  data() {
    return {
      loading: false,
      content: null,
      error: null
    }
  },
  created() {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async fetchData() {
      this.error = this.post = null;
      this.loading = true;
      const entries = await client.getEntries({
        'content_type': 'information',
        'fields.slug': this.$route.params.slug
      });
      if (entries.total >= 1) {
        this.content = entries.items[0]
      } else if (entries.errors) {
        this.$router.push('/')
      }
    }
  }

}
</script>
<style lang="scss">
$info-font-size-h1: 2.5em !default; // ~ 49px
$info-font-size-h2: 1.8em !default; // ~ 35px
$info-font-size-h3: 1.7em !default; // ~ 28px

.dynamic-content {
  padding-top: 60px;
}

.h1 {
  color: #f4d35e;
  text-shadow: 1px 1px 2px #ee964b;
}

.information {
  color: white;
  padding: 10px;
  background: rgba(14, 46, 94, 0.9);
  border-radius: 10px;

  h1 {
    font-size: $info-font-size-h1;
  }

  h2 {
    font-size: $info-font-size-h2;
  }

  h3 {
    font-size: $info-font-size-h3;
  }

  a, a:visited {
    color: white;
    font-weight: bold;
  }
}
</style>
